import { AssetImage } from '@facephi/inphinite-common';
import { Dropdown, FlexContainer, Input, Modal } from '@facephi/ui-react';
import styled from 'styled-components';

export const DropdownAntiFraud = styled(Dropdown)`
  width: 7.4rem;
` as any;

export const HeaderBanned = styled(FlexContainer)`
  margin-bottom: 6rem;
` as any;

export const HeaderRulesStyles = styled(FlexContainer)`
  margin: 2rem 1.6rem;
` as any;

export const RulesTabsWrapper = styled(FlexContainer)`
  height: 100%;
` as any;

export const ModalIPStyles = styled(Modal)`
  width: 52rem;
`;

export const ModalFaceInput = styled(Input)`
  width: 100%;
` as any;

export const TableFaceImg = styled(AssetImage)`
  width: 5rem;
  aspect-ratio: 1;
  object-fit: cover;
`;

export const TablePopImg = styled.img`
  width: 5rem;
  object-fit: cover;
`;
